import { render, staticRenderFns } from "./newIndex.vue?vue&type=template&id=0c2af82c&scoped=true&"
import script from "./newIndex.vue?vue&type=script&lang=js&"
export * from "./newIndex.vue?vue&type=script&lang=js&"
import style0 from "./newIndex.vue?vue&type=style&index=0&id=0c2af82c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2af82c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c2af82c')) {
      api.createRecord('0c2af82c', component.options)
    } else {
      api.reload('0c2af82c', component.options)
    }
    module.hot.accept("./newIndex.vue?vue&type=template&id=0c2af82c&scoped=true&", function () {
      api.rerender('0c2af82c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newIndex.vue"
export default component.exports